(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["featured-products"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper('.swiper-container--featured-products', {
    speed: 600,
    loop: true,
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 20,
    pagination: '.slider--featured-products-pagination',
    nextButton: '.slider--featured-products-next',
    prevButton: '.slider--featured-products-prev',
    breakpoints: {
      959: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    

(function($){
  $(function(){

    var swiper = new Swiper('.slider--index', {
      pagination: '.slider--index .swiper-pagination',
      paginationClickable: true,
      prevButton: '.slider--index .swiper-button-prev',
      nextButton: '.slider--index .swiper-button-next',
      loop: true,
	  autoplay: 4000,
      autoplayDisableOnInteraction: false
    });

  });
})(jQuery)

  } catch(e) { console.error(e); }
})();

})();
